
import { Plus, CheckSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ProductsHeaderProps {
  isSelectionMode: boolean;
  toggleSelectionMode: () => void;
  onAddNew: () => void;
}

export function ProductsHeader({ 
  isSelectionMode, 
  toggleSelectionMode, 
  onAddNew 
}: ProductsHeaderProps) {
  return (
    <div className="flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Products</h1>
        <p className="text-muted-foreground mt-1">
          Manage product recommendations for your packing lists
        </p>
      </div>
      <div className="flex gap-2">
        <Button 
          onClick={toggleSelectionMode} 
          variant={isSelectionMode ? "secondary" : "outline"} 
          className="hidden sm:flex"
        >
          <CheckSquare className="mr-2 h-4 w-4" />
          {isSelectionMode ? "Exit Selection" : "Select Products"}
        </Button>
        <Button onClick={onAddNew}>
          <Plus className="mr-2 h-4 w-4" />
          Add New Product
        </Button>
      </div>
    </div>
  );
}
